import Button from "../../components/Button";

const ReportWizardFooter = ({ buttons }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "var(--gap-base)",
      }}
    >
      {buttons.map((item, idx) => (
        <Button key={`fw-button-${idx}-${item?.caption}`} {...item} />
      ))}
    </div>
  );
};

export default ReportWizardFooter;
